//#region src/framework/theme/util/storybook.ts
const BASIC_COLOR_VARIANTS = [
	"black",
	"white",
	"currentColor"
];
const COLOR_VARIANTS = [
	"gray",
	"saving",
	"primary",
	"secondary",
	"error",
	"success",
	"warning",
	"info",
	"notice"
];
const COLOR_VARIANTS_SUMMARY = COLOR_VARIANTS.join(" | ");

//#endregion
export { BASIC_COLOR_VARIANTS, COLOR_VARIANTS, COLOR_VARIANTS_SUMMARY };